import React from 'react';
import { DISCLOSED_ENTITY } from '../lib/entity';

/**
 * Entity Disclosure block — identifies who operates this website.
 *
 * Renders the public disclosure name and address from lib/entity
 * (STARSEED-CAPMARKETS-055): "EchoSense Capital Club" + the Kamas, UT
 * address. The incorporated entity's formation facts (filing number, EIN,
 * registered agent) are no longer part of the public footer; they remain on
 * the Compliance ID Card, which reads LEGAL_ENTITY from the same module.
 */
export const LegalEntityDisclosure = ({ variant = 'footer' }) => {
  const base = 'text-platinum/40 text-xs leading-relaxed';
  return (
    <div
      data-testid="legal-entity-disclosure"
      className={
        variant === 'footer'
          ? `${base} text-center max-w-3xl mx-auto pt-2`
          : base
      }
    >
      <span className="text-platinum/60 font-medium">{DISCLOSED_ENTITY.name}</span>
      <br />
      <span>{DISCLOSED_ENTITY.address}</span>
    </div>
  );
};

export default LegalEntityDisclosure;
